import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75dc2f5d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75dc2f5d')) {
      api.createRecord('75dc2f5d', component.options)
    } else {
      api.reload('75dc2f5d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=75dc2f5d&", function () {
      api.rerender('75dc2f5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/authProduct/index.vue"
export default component.exports